









































































































































import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import { CrudService } from "@/shared/core/services/crudService";
import { Settings } from "@/shared/core/services/configService";
import store from "@/shared/core/store";

@Component
export default class LessonPage extends Vue {
  lesson: any = null;
  playUrl: string = "";
  progressStatus: number = 0;
  percentWatched: number = 0;
  activeTab: string = "content";

  // Submission state
  submission: any = null;
  submissionPlayUrl: string = "";
  submissionComments: any[] = [];
  showUploadForm: boolean = false;
  uploading: boolean = false;
  uploadPercent: number = 0;
  uploadDone: boolean = false;

  private _progressTimer: any = null;

  get customerId(): number {
    try {
      const raw = localStorage.getItem(window.location.host + "_cc");
      if (raw) { const p = JSON.parse(raw); const v = p.value || p; return (typeof v === "string" ? JSON.parse(v) : v).id; }
    } catch (e) {}
    return 0;
  }

  get isCompleted(): boolean {
    return this.progressStatus === 2;
  }

  get statusLabel(): string {
    if (!this.submission) return "";
    const s = this.submission.status;
    if (s === 0) return this.$t("Pending review").toString();
    if (s === 1) return this.$t("Approved").toString();
    if (s === 2) return this.$t("Needs correction").toString();
    return "";
  }

  async mounted() {
    const lessonId = this.$route.params.lessonId;
    if (!lessonId) return;

    const crud = new CrudService();
    const url = `${Settings.HostName}/api/public-courses/lesson/${lessonId}?customerId=${this.customerId}`;
    const data = await crud.httpGet(url);
    if (!data || !data.ok) return;

    this.lesson = data.lesson;
    this.playUrl = data.playUrl || "";
    if (data.progress) {
      this.progressStatus = data.progress.status;
      this.percentWatched = data.progress.percentWatched;
    }
    this.startProgressTracking();

    if (this.lesson.requiresSubmission) {
      await this.loadSubmission();
    }
  }

  beforeDestroy() {
    if (this._progressTimer) clearTimeout(this._progressTimer);
  }

  async loadSubmission() {
    const url = `${Settings.HostName}/api/public-courses/submission?lessonId=${this.lesson.id}&customerId=${this.customerId}`;
    const data = await new CrudService().httpGet(url);
    if (!data || !data.ok) return;
    this.submission = data.submission;
    this.submissionPlayUrl = data.playUrl || "";
    this.submissionComments = data.comments || [];
  }

  startProgressTracking() {
    if (!this.playUrl || this.isCompleted) return;
    if (this.progressStatus === 0) {
      this.reportProgress(10);
    }
    const duration = this.lesson?.durationSeconds || 300;
    const waitMs = Math.max(duration * 0.9 * 1000, 10000);
    this._progressTimer = setTimeout(() => {
      if (!this.isCompleted) this.reportProgress(95);
    }, waitMs);
  }

  async reportProgress(percent: number) {
    const url = `${Settings.HostName}/api/public-courses/progress`;
    const data = await new CrudService().httpPost(url, {
      lessonId: this.lesson.id,
      customerId: this.customerId,
      percentWatched: percent
    });
    if (data && data.ok) {
      this.progressStatus = data.status;
      this.percentWatched = data.percentWatched;
    }
  }

  async completeManual() {
    const url = `${Settings.HostName}/api/public-courses/complete-manual`;
    const data = await new CrudService().httpPost(url, {
      lessonId: this.lesson.id,
      customerId: this.customerId
    });
    if (data && data.ok) {
      this.progressStatus = 2;
    }
  }

  startUpload() {
    this.showUploadForm = true;
    this.uploadDone = false;
  }

  triggerFileInput() {
    const input = this.$refs.fileInput as HTMLInputElement;
    if (input) input.click();
  }

  async onFileSelected(e: Event) {
    const input = e.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];

    this.uploading = true;
    this.uploadPercent = 0;
    const crud = new CrudService();

    const createRes = await crud.httpPost(`${Settings.HostName}/api/public-courses/create-submission-video`, {
      lessonId: this.lesson.id,
      customerId: this.customerId
    });
    if (!createRes || !createRes.ok) {
      this.uploading = false;
      return;
    }

    const success = await this.uploadFile(file, createRes.uploadUrl, createRes.authKey);
    if (!success) {
      this.uploading = false;
      return;
    }

    const submitRes = await crud.httpPost(`${Settings.HostName}/api/public-courses/submit`, {
      lessonId: this.lesson.id,
      customerId: this.customerId,
      videoId: createRes.videoId
    });

    this.uploading = false;
    if (submitRes && submitRes.ok) {
      this.uploadDone = true;
      this.showUploadForm = false;
      await this.loadSubmission();
    }
  }

  uploadFile(file: File, url: string, authKey: string): Promise<boolean> {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url, true);
      xhr.setRequestHeader("AccessKey", authKey);
      xhr.upload.onprogress = (e: ProgressEvent) => {
        if (e.lengthComputable) this.uploadPercent = Math.round((e.loaded / e.total) * 100);
      };
      xhr.onload = () => resolve(xhr.status >= 200 && xhr.status < 300);
      xhr.onerror = () => resolve(false);
      xhr.send(file);
    });
  }

  formatDate(d: string): string {
    if (!d) return "";
    return new Date(d).toLocaleDateString();
  }

  fmtTime(s: number): string {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return m + ":" + (sec < 10 ? "0" : "") + sec;
  }
}
